module.exports = __webpack_public_path__ + "img/flag-brazil.a3e2da6.svg";